import {
  useLinkToolbarButton,
  useLinkToolbarButtonState,
} from "@platejs/link/react";
import { Link } from "lucide-react";
import { memo } from "react";
import { ToolbarButton } from "./toolbar";

export const LinkToolbarButton = memo(function LinkToolbarButton() {
  const state = useLinkToolbarButtonState();
  const { props: buttonProps } = useLinkToolbarButton(state);

  return (
    <ToolbarButton {...buttonProps} data-plate-focus tooltip="Link">
      <Link />
    </ToolbarButton>
  );
});
